<app-loading *ngIf="(isLoading$ | async)" title="step groups"></app-loading>


<div class="login-container px-xs-1">
    <div class="login-heading">
        <h1 i18n>Welcome back!</h1>
        <h2 i18n="@@loginDescription" class="pb-4 small">Please log in to your Lorex account to continue</h2>
        <form [formGroup]="loginForm" *ngIf="loginForm">
            <div class="form-wrapper">
                <div class="input-inner">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.718" height="19.27" viewBox="0 0 17.718 19.27">
              <path id="account_icon" data-name="account icon"
                    d="M.511,18.27a.519.519,0,0,1-.395-.184.525.525,0,0,1-.108-.425,8.508,8.508,0,0,1,8.345-6.895h0A8.508,8.508,0,0,1,16.7,17.661a.51.51,0,0,1-.5.608Zm3-13.416A4.853,4.853,0,1,1,8.359,9.706,4.86,4.86,0,0,1,3.506,4.854Z"
                    transform="translate(0.503 0.5)" fill="#73767a" stroke="rgba(0,0,0,0)" stroke-miterlimit="10"
                    stroke-width="1"/>
            </svg>
          </span>
                    <label for="email" class="visually-hidden">Email</label>
                    <input id="email" formControlName="email" class="custom-input" type="email" i18n-placeholder="Email" placeholder="Email"
                           [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
                    <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                        <div *ngIf="f['email'].errors?.['required']"><span i18n="@@emailRequired">Email is required</span></div>
                        <div *ngIf="f['email'].errors?.['email']"><span i18n="@@emailValid">Email is invalid</span></div>
                    </div>
                </div>
                <div class="input-inner">
                    <div class="input-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14.348" height="18.269" viewBox="0 0 14.348 18.269">
                            <path id="lock_icon" data-name="lock icon"
                                  d="M842.643,203.433h-.5v-3.579a4.769,4.769,0,0,0-9.537,0v3.579h-.5a1.9,1.9,0,0,0-1.9,1.9v6.195a1.9,1.9,0,0,0,1.9,1.9h10.54a1.906,1.906,0,0,0,1.908-1.9v-6.188A1.908,1.908,0,0,0,842.643,203.433Zm-8.16,0v-3.579a2.892,2.892,0,0,1,5.782,0v3.579Z"
                                  transform="translate(-830.202 -195.163)" fill="#73767a"/>
                        </svg>

                    </div>
                    <span class="input-icon-eye" (click)="togglePassword()">
            <ng-container *ngIf="this.passwordToggle">
              <img src="assets/images/eye-icon.svg" alt="Reveal Password">

            </ng-container>
            <ng-container *ngIf="!this.passwordToggle">
              <svg id="hide_icon" data-name="hide icon" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink" width="17.434" height="13.32" viewBox="0 0 17.434 13.32">
                <defs>
                  <clipPath id="clip-path">
                    <rect id="Rectangle_2226" data-name="Rectangle 2226" width="17.434" height="13.32" fill="#bdc1c6"/>
                  </clipPath>
                </defs>
                <g id="Group_7890" data-name="Group 7890" transform="translate(0 0)" clip-path="url(#clip-path)">
                  <path id="Path_3845" data-name="Path 3845"
                        d="M22,9a1.4,1.4,0,0,0-.16-.657,11.056,11.056,0,0,0-2.366-2.9L16.513,8.511a2.634,2.634,0,0,1,.04.48,3.259,3.259,0,0,1-3.269,3.269,2.54,2.54,0,0,1-.36-.023l-2.252,2.338a8.932,8.932,0,0,0,2.612.4v.006a9.131,9.131,0,0,0,5.093-1.566,11.345,11.345,0,0,0,3.475-3.761A1.444,1.444,0,0,0,22.006,9Z"
                        transform="translate(-4.572 -2.331)" fill="#bdc1c6"/>
                  <path id="Path_3846" data-name="Path 3846"
                        d="M11.295,4.655l2.389-2.481.692-.72A.815.815,0,0,0,14.6.945a.815.815,0,0,0-.251-.7.852.852,0,0,0-1.212.023L12.1,1.345A9.225,9.225,0,0,0,8.711.682V.671A9.127,9.127,0,0,0,3.624,2.237,11.328,11.328,0,0,0,.155,6,1.382,1.382,0,0,0,0,6.655v.029a1.382,1.382,0,0,0,.155.629A11.417,11.417,0,0,0,3.093,10.69L1.961,11.868a.857.857,0,0,0,.617,1.452.835.835,0,0,0,.617-.263l.657-.68.714-.743L6.8,9.313ZM5.442,6.661A3.269,3.269,0,0,1,8.711,3.391a3.2,3.2,0,0,1,1.195.229L5.716,7.97a3.243,3.243,0,0,1-.274-1.309"
                        transform="translate(0 0)" fill="#bdc1c6"/>
                </g>
              </svg>
            </ng-container>
          </span>
                    <label *ngIf="!this.passwordToggle" for="Password" class="visually-hidden">Password</label>
                    <input *ngIf="!this.passwordToggle" formControlName="password" class="custom-input" type="password" id="Password"
                           i18n-placeholder="Password" placeholder="Password"
                           [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">
                    <label *ngIf="this.passwordToggle" for="revealPassword" class="visually-hidden">Password</label>
                    <input *ngIf="this.passwordToggle" formControlName="password" class="custom-input" type="text" id="revealPassword"
                           i18n-placeholder="Password" placeholder="Password"
                           [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">
                    <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                        <div *ngIf="f['password'].errors?.['required']"><span i18n="@@passwordRequired">Password is required</span>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="select-countery" *ngIf="!(isLoading$ | async)">
                        <div>
                            <input formControlName="rememberMe" type="checkbox" id="html">
                            <label for="html" i18n="@@rememberMeLabel">Remember me</label>
                        </div>

                        <div class="select-language-login">
                            <label for="countrySelect" id="countrySelectLabel" class="visually-hidden">Select your country</label>
                            <ng-select [items]="countryDomains" formControlName="country" [searchable]="false" bindLabel="countryCode"
                                       bindValue="countryCode" id="countrySelect" aria-labelledby="countrySelectLabel">
                                <ng-template ng-label-tmp let-item="item">
                                    <div class="ng-select-label-content" style="padding-top: 4px;">{{ item?.countryCode.toUpperCase() }}&nbsp;
                                        <img height="20" width="20" style="padding-bottom: 4px;" [src]="item.countryflag" alt="country-flag"/>&nbsp;
                                    </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    {{ item.countryCode.toUpperCase() }} &nbsp;
                                    <img height="20" width="20" [ngSrc]="item.countryflag" alt=" "/>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>

                    <div class="loader-wrapper">
                        <button class="btn btn-secondary btn-width" [disabled]="disabled" (click)="onCLickLogin(loginForm)"
                                i18n="@@logInButton">Log in
                        </button>
                        <div class="spinner-border float-end text-light" *ngIf="btnLoader" style="width: 1.5rem; height: 1.5rem;"
                             role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </div>
                </div>
                <div class="signup-content">
                    <a href="https://www.lorex.com/account/register" target="_blank" i18n="@@signUpLink">Sign up</a>
                    <a href="https://www.lorex.com/account/login?return_url=/account#recover-password" target="_blank"
                       i18n="@@forgotPassword">Forgot my password</a>
                </div>
            </div>
        </form>
    </div>
</div>